import React, { FC } from "react";
import ProfilePhoto from "../../../ProfilePhoto/ProfilePhoto";
import { UserT } from "../../../../models/models";
import { clss } from "../../../../utils/helpers/styleHelpers";
import Button, { ButtonModeE } from "../../../Button/Button";
import useAccount from "./../../../../utils/hooks/useAccount";
import Icon from "../../../Icon/Icon";
import {
  AccessLevelE,
  ClientTypeE,
  IconColorE,
  UserRoleE,
} from "../../../../models/enums";
import {
  getAllUsersFromStorage,
  removeUserFromStorage,
} from "../../../../utils/helpers/tokenStorage";
import { useAppDispatch, useAppSelector } from "./../../../../store/hooks";
import { setLoggedUsers } from "../../../../store/slices/authSlice";
import { isMobileOrTablet } from "../../../../utils/helpers/mediaQueries";
import { RoutesE } from "../../../../routes/routesData";
import { selectIsChangingAccount } from "../../../../store/selectors/authSelectors";

import styles from "./userItem.module.scss";

type UserItemPropTypes = {
  user: UserT;
  isCurrent?: boolean;
  onClose?: () => void;
  profilePhotoSrc?: any;
};

/**
 * User item for user profile dropdown list (within header)
 * */

const UserItem: FC<UserItemPropTypes> = ({
  user,
  isCurrent,
  onClose,
  profilePhotoSrc,
}) => {
  const { changeAccount } = useAccount();
  const dispatch = useAppDispatch();
  const isChangingAccount = useAppSelector(selectIsChangingAccount);

  const navigateToManageAccount = () => {
    onClose && onClose();
  };

  const handleChangeUser = async (userId: string) => {
    await changeAccount(userId);
    onClose && onClose();
  };

  const removeLoggedUser = (e: any) => {
    e.stopPropagation();
    removeUserFromStorage(user.userId);

    const allUsers = getAllUsersFromStorage();

    if (allUsers?.length) {
      dispatch(setLoggedUsers(allUsers));
    } else {
      dispatch(setLoggedUsers([]));
    }
  };

  return (
    <div
      className={clss([
        isCurrent ? styles.currentWrapper : styles.wrapper,
        isCurrent ? styles.dark : styles.light,
      ])}
      onClick={() => {
        !isCurrent && !isChangingAccount && handleChangeUser(user.userId);
      }}
    >
      <div className={styles.profilePhotoWrapper}>
        {isChangingAccount && (
          <Icon name="loading" className={styles.loadingIcon} />
        )}
        <ProfilePhoto src={profilePhotoSrc} role={user?.role} />
      </div>
      <div className={styles.userData}>
        <span className={styles.fullName}>{user.userName}</span>
        <span className={styles.email}>
          {isCurrent
            ? user.email
            : user.role === UserRoleE.GlobalAdminAndAdminContentManager
            ? "Content manager"
            : user.accessLevel === AccessLevelE.GlobalAdmin
            ? "Global Admin"
            : ClientTypeE[user.clientType]}
        </span>
        {!isCurrent && !isMobileOrTablet() && (
          <Icon
            name="close"
            color={IconColorE.WHITE}
            className={styles.removeIcon}
            onClick={removeLoggedUser}
          />
        )}
      </div>
      {isCurrent && user.role !== UserRoleE.DeliveryService && (
        <Button
          icon="settings"
          mode={ButtonModeE.LINK}
          onClick={navigateToManageAccount}
          link={RoutesE.SETTINGS_USER}
        >
          Manage account
        </Button>
      )}
    </div>
  );
};

export default UserItem;
